import Model from './Model';


const PROPERTIES = {
  id: {
    name: 'ID',
    isUserDisplayable: false,
  },
  version: {
    name: 'Version',
  },
  dateCreated: {
    name: 'Date created',
  },
  changelog: {
    name: 'Changelog',
  },
  dataTypes: {
    name: 'Data types',
  },
  security: {
    name: 'Security',
  },
  environment: {
    name: 'Environment',
  },
};


class ApiVersion extends Model {
  getWhitelistedProperties() {
    return PROPERTIES;
  }
}


export default ApiVersion;
